export default __webpack_public_path__ + "static/media/saleAction.903a5abf.svg";